const getPaymentMethodName = require('./getPaymentMethodName');
const getPaymentMethodTitle = require('./getPaymentMethodTitle');
const getPaymentMethodCode = require('./getPaymentMethodCode');
const getAmountPaid = require('./getAmountPaid');
const paymentAuthResults = require('./paymentAuthResults');
const getPayments = require('./getPayments');
const statuses = require('./statuses');
const paymentMethods = require('./paymentMethods');
const paymentErrors = require('./paymentErrors');
const formatPayment = require('./formatPayment');

module.exports = {
  getPaymentMethodName,
  getPaymentMethodTitle,
  getPaymentMethodCode,
  getAmountPaid({ includeUnchargedOnlinePayments = true, includeCredits = true, initial = false, methodName } = { includeUnchargedOnlinePayments: true, includeCredits: true, initial: false }){
    return getAmountPaid({ 
      payments: this.payments, 
      includeUnchargedOnlinePayments, 
      includeCredits,
      initial,
      methodName
    });
  },
  getPayments(methodName){
    return getPayments({ payments: this.payments, methodName });
  },
  getPaymentStatuses: () => statuses,
  getPaymentMethods: () => paymentMethods,
  formatPayment,
  paymentErrors,
  paymentAuthResults,
  getPaymentAuthResultName: code => paymentAuthResults[code],
  getPaymentErrorName: code => paymentErrors[code]
};